import React from "react";

import { red, green, grey, yellow } from "@material-ui/core/colors";
import ErrorIcon from '@material-ui/icons/Error';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import SyncIcon from '@material-ui/icons/Sync';
import { Tooltip } from '@material-ui/core';

export default function showStatusKode(statuskode, statusbesked, statustid) {

  //console.log(statuskode);
  //console.log(statusbesked);
  //console.log(statustid);

  // No status calculated
  if(statuskode==null || statuskode===false) {
    return (
      <Tooltip title={"Ingen kontrol er kørt endnu."}>
        <NotInterestedIcon style={{ color: grey[500] }} />
      </Tooltip>
      )
  }

  // no status
  if (!statusbesked) {
    statusbesked = 'Status er ikke angivet!'
  }

  // no time
  if (!statustid) {
    statustid = 'Tid er ikke angivet!'
  }

  // consolidate
  let message = statusbesked + ' - ' + statustid

  switch(statuskode) {
    case 0:
      return (
      <Tooltip title={message}>
        <CheckCircleIcon style={{ color: green[500] }} />
      </Tooltip>
      )
    case 99:
      return (
        <Tooltip title={message}>
          <SyncIcon style={{ color: yellow[700] }} />
        </Tooltip>
        )  
    default:
      return (
        <Tooltip title={message}>
          <ErrorIcon style={{ color: red[500] }} />
        </Tooltip>
      )
  }
}